import { useQuery } from '@tanstack/react-query'
import { LobsterMasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { labelMasterQueryKeys } from './queryKeys'

type Params = {
  keywords: string[]
  limit: number
  offset: number
}

export const useQueryLabelMasters = (params: Params) => {
  return useQuery({
    queryKey: labelMasterQueryKeys.labelMasters.list(params),
    queryFn: () =>
      baseClient.getApi(LobsterMasterApi).getInternalLabelMasters({
        keywords: params.keywords.join(','),
        limit: String(params.limit),
        offset: String(params.offset),
      }),
    retry: 0,
    staleTime: 60_000,
    throwOnError: true,
  })
}
